// extracted by mini-css-extract-plugin
export default {"root_div":"services_modal_root_div__MLpz2","item_div":"services_modal_item_div__MXL+-"};